import { jsx as _jsx } from "react/jsx-runtime";
import { getChain } from "@gearbox-protocol/sdk/onchain";
import { ArbitrumLogo } from "./ArbitrumLogo";
import { AvalancheLogo } from "./AvalancheLogo";
import { BaseLogo } from "./BaseLogo";
import { BerachainLogo } from "./BerachainLogo";
import { BNBLogo } from "./BNBLogo";
import { EtherlinkLogo } from "./EtherlinkLogo";
import { EthLogo } from "./EthLogo";
import { HemiLogo } from "./HemiLogo";
import { LiskLogo } from "./LiskLogo";
import { MegaETHLogo } from "./MegaETHLogo";
import { MonadLogo } from "./MonadLogo";
import { OptimismLogo } from "./OptimismLogo";
import { PlasmaLogo } from "./PlasmaLogo";
import { SomniaLogo } from "./SomniaLogo";
import { SonicLogo } from "./SonicLogo";
import { WorldchainLogo } from "./WorldchainLogo";
export const NetworkLogo = props => {
    let net;
    try {
        const chain = "chainId" in props ? getChain(props.chainId) : getChain(props.network);
        net = chain.network;
    }
    catch { }
    switch (net) {
        case "Mainnet":
            return _jsx(EthLogo, { ...props });
        case "Optimism":
            return _jsx(OptimismLogo, { ...props });
        case "Arbitrum":
            return _jsx(ArbitrumLogo, { ...props });
        case "Sonic":
            return _jsx(SonicLogo, { ...props });
        case "Base":
            return _jsx(BaseLogo, { ...props });
        case "Avalanche":
            return _jsx(AvalancheLogo, { ...props });
        case "Berachain":
            return _jsx(BerachainLogo, { ...props });
        case "BNB":
            return _jsx(BNBLogo, { ...props });
        case "WorldChain":
            return _jsx(WorldchainLogo, { ...props });
        case "Etherlink":
            return _jsx(EtherlinkLogo, { ...props });
        case "Hemi":
            return _jsx(HemiLogo, { ...props });
        case "Lisk":
            return _jsx(LiskLogo, { ...props });
        case "Plasma":
            return _jsx(PlasmaLogo, { ...props });
        case "Monad":
            return _jsx(MonadLogo, { ...props });
        case "Somnia":
            return _jsx(SomniaLogo, { ...props });
        case "MegaETH":
            return _jsx(MegaETHLogo, { ...props });
        default:
            return null;
    }
};
